import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export default () => _jsx(_Fragment, { children: "Web view for component not supported" });
